import { render, staticRenderFns } from "./opendata.vue?vue&type=template&id=01897a1c&scoped=true"
import script from "./opendata.vue?vue&type=script&lang=js"
export * from "./opendata.vue?vue&type=script&lang=js"
import style0 from "./opendata.vue?vue&type=style&index=0&id=01897a1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01897a1c",
  null
  
)

export default component.exports